import { enqueueSnackbar } from 'actions';

import {
	GetFailuresFiltersRequest,
	GetFailuresPointsVoiceRequest,
	GetFailuresPointsPacketRequest,
	GetDriveTestsCitiesRequest,
	GetDriveTestsDrivesRequest,
	GetDriveTestsDatesRequest,
	GetDriveTestRequest,
	GetDriveTestScannerCodesRequest,
	GetDriveTestScannerRequest,
	GetTopologyRequest,
	GetTopologyLabelsRequest,
	GetDriveTestsTechBandVoiceRequest,
	GetDriveTestsTechBandPacketRequest,
	GetDriveTestSummaryDropdownRequest,
	GetDriveTestSummaryRequest,
	GetSitesIdsRequest,
	GetSiteIdLocationRequest,
	GetScannerRouteRequest,
	GetCarriersColorsRequest,
	SaveCarrierColorRequest,
} from '../requests/FailuresMapRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const RESET_FIELDS = 'RESET_FIELDS';
export const GET_FAILURES_FILTERS = 'GET_FAILURES_FILTERS';
export const GET_FAILURES_VOICE = 'GET_FAILURES_VOICE';
export const GET_FAILURES_PACKET = 'GET_FAILURES_PACKET';
export const GET_DRIVETESTS_CITIES = 'GET_DRIVETESTS_CITIES';
export const GET_DRIVETESTS_DRIVES = 'GET_DRIVETESTS_DRIVES';
export const GET_DRIVETESTS_DATES = 'GET_DRIVETESTS_DATES';
export const SET_SELECTED_DATES = 'SET_SELECTED_DATES';
export const GET_DRIVETEST = 'GET_DRIVETEST';
export const GET_DRIVETEST_SCANNER_CODES = 'GET_DRIVETEST_SCANNER_CODES';
export const GET_DRIVETEST_SCANNER = 'GET_DRIVETEST_SCANNER';
export const GET_TOPOLOGY_2G = 'GET_TOPOLOGY_2G';
export const GET_TOPOLOGY_3G = 'GET_TOPOLOGY_3G';
export const GET_TOPOLOGY_4G = 'GET_TOPOLOGY_4G';
export const GET_TOPOLOGY_5G = 'GET_TOPOLOGY_5G';
export const GET_TOPOLOGY_LABELS_2G = 'GET_TOPOLOGY_LABELS_2G';
export const GET_TOPOLOGY_LABELS_3G = 'GET_TOPOLOGY_LABELS_3G';
export const GET_TOPOLOGY_LABELS_4G = 'GET_TOPOLOGY_LABELS_4G';
export const GET_TOPOLOGY_LABELS_5G = 'GET_TOPOLOGY_LABELS_5G';
export const GET_DRIVETESTS_TECH_BAND_VOICE = 'GET_DRIVETESTS_TECH_BAND_VOICE';
export const GET_DRIVETESTS_TECH_BAND_PACKET = 'GET_DRIVETESTS_TECH_BAND_PACKET';
export const GET_DRIVETEST_SUMMARY_DROPDOWN = 'GET_DRIVETEST_SUMMARY_DROPDOWN';
export const GET_DRIVETEST_SUMMARY = 'GET_DRIVETEST_SUMMARY';
export const GET_SITES_IDS = 'GET_SITES_IDS';
export const GET_SITE_ID_LOCATION = 'GET_SITE_ID_LOCATION';
export const GET_SCANNER_ROUTE = 'GET_SCANNER_ROUTE';

// Map Compare
export const GET_FAILURES_FILTERS_COMPARE = 'GET_FAILURES_FILTERS_COMPARE';
export const GET_FAILURES_VOICE_COMPARE = 'GET_FAILURES_VOICE_COMPARE';
export const GET_FAILURES_PACKET_COMPARE = 'GET_FAILURES_PACKET_COMPARE';
export const GET_DRIVETESTS_CITIES_COMPARE = 'GET_DRIVETESTS_CITIES_COMPARE';
export const GET_DRIVETESTS_DRIVES_COMPARE = 'GET_DRIVETESTS_DRIVES_COMPARE';
export const GET_DRIVETESTS_DATES_COMPARE = 'GET_DRIVETESTS_DATES_COMPARE';
export const SET_SELECTED_DATES_COMPARE = 'SET_SELECTED_DATES_COMPARE';
export const GET_DRIVETEST_COMPARE = 'GET_DRIVETEST_COMPARE';
export const GET_DRIVETEST_SCANNER_CODES_COMPARE = 'GET_DRIVETEST_SCANNER_CODES_COMPARE';
export const GET_DRIVETEST_SCANNER_COMPARE = 'GET_DRIVETEST_SCANNER_COMPARE';
export const GET_TOPOLOGY_2G_COMPARE = 'GET_TOPOLOGY_2G_COMPARE';
export const GET_TOPOLOGY_3G_COMPARE = 'GET_TOPOLOGY_3G_COMPARE';
export const GET_TOPOLOGY_4G_COMPARE = 'GET_TOPOLOGY_4G_COMPARE';
export const GET_TOPOLOGY_5G_COMPARE = 'GET_TOPOLOGY_5G_COMPARE';
export const GET_TOPOLOGY_LABELS_2G_COMPARE = 'GET_TOPOLOGY_LABELS_2G_COMPARE';
export const GET_TOPOLOGY_LABELS_3G_COMPARE = 'GET_TOPOLOGY_LABELS_3G_COMPARE';
export const GET_TOPOLOGY_LABELS_4G_COMPARE = 'GET_TOPOLOGY_LABELS_4G_COMPARE';
export const GET_TOPOLOGY_LABELS_5G_COMPARE = 'GET_TOPOLOGY_LABELS_5G_COMPARE';
export const GET_DRIVETESTS_TECH_BAND_VOICE_COMPARE = 'GET_DRIVETESTS_TECH_BAND_VOICE_COMPARE';
export const GET_DRIVETESTS_TECH_BAND_PACKET_COMPARE = 'GET_DRIVETESTS_TECH_BAND_PACKET_COMPARE';
export const GET_DRIVETEST_SUMMARY_COMPARE = 'GET_DRIVETEST_SUMMARY_COMPARE';
export const GET_SCANNER_ROUTE_COMPARE = 'GET_SCANNER_ROUTE_COMPARE';

// Global
export const TOGGLE_FILTERS = 'TOGGLE_FILTERS';
export const CLEAR_FORM = 'CLEAR_FORM';
export const TOGGLE_SUMMARY_DIALOG = 'TOGGLE_SUMMARY_DIALOG';
export const TOGGLE_CARRIERS_COLORS_DIALOG = 'TOGGLE_CARRIERS_COLORS_DIALOG';
export const GET_CARRIERS_COLORS = 'GET_CARRIERS_COLORS';
export const TOGGLE_CARRIERS_COLORS_PICKER_DIALOG = 'TOGGLE_CARRIERS_COLORS_PICKER_DIALOG';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onResetFields = () => ({
	type: RESET_FIELDS,
});

const onGetFailuresFilters = (value) => ({
	type: GET_FAILURES_FILTERS,
	failuresFilters: value
});

const onGetFailuresPointsVoice = (value) => ({
	type: GET_FAILURES_VOICE,
	failuresVoice: value
});

const onGetFailuresPointsPacket = (value) => ({
	type: GET_FAILURES_PACKET,
	failuresPacket: value
});

const onGetDriveTestsCities = (value) => ({
	type: GET_DRIVETESTS_CITIES,
	cities: value
});

const onGetDriveTestsDrives = (value) => ({
	type: GET_DRIVETESTS_DRIVES,
	drives: value
});

const onGetDriveTestsDates = (value) => ({
	type: GET_DRIVETESTS_DATES,
	dates: value
});

const onSetSelectedDates = (value) => ({
	type: SET_SELECTED_DATES,
	selectedDates: value
});

const onGetDriveTest = (value) => ({
	type: GET_DRIVETEST,
	driveTest: value
});

const onGetDriveTestScannerCodes = (value) => ({
	type: GET_DRIVETEST_SCANNER_CODES,
	driveTestScannerCodes: value
});

const onGetDriveTestScanner = (value) => ({
	type: GET_DRIVETEST_SCANNER,
	driveTestScanner: value
});

const onGetTopology2g = (value) => ({
	type: GET_TOPOLOGY_2G,
	topology2gData: value
});

const onGetTopology3g = (value) => ({
	type: GET_TOPOLOGY_3G,
	topology3gData: value
});

const onGetTopology4g = (value) => ({
	type: GET_TOPOLOGY_4G,
	topology4gData: value
});

const onGetTopology5g = (value) => ({
	type: GET_TOPOLOGY_5G,
	topology5gData: value
});

const onGetTopologyLabels2g = (value) => ({
	type: GET_TOPOLOGY_LABELS_2G,
	topologyLabels2gData: value
});

const onGetTopologyLabels3g = (value) => ({
	type: GET_TOPOLOGY_LABELS_3G,
	topologyLabels3gData: value
});

const onGetTopologyLabels4g = (value) => ({
	type: GET_TOPOLOGY_LABELS_4G,
	topologyLabels4gData: value
});

const onGetTopologyLabels5g = (value) => ({
	type: GET_TOPOLOGY_LABELS_5G,
	topologyLabels5gData: value
});

const onGetDriveTestsTechBandVoice = (value) => ({
	type: GET_DRIVETESTS_TECH_BAND_VOICE,
	techBandVoice: value
});

const onGetDriveTestsTechBandPacket = (value) => ({
	type: GET_DRIVETESTS_TECH_BAND_PACKET,
	techBandPacket: value
});

const onGetDriveTestSummaryDropdown = (value) => ({
	type: GET_DRIVETEST_SUMMARY_DROPDOWN,
	drivetestSummaryDropdown: value
});

const onGetDriveTestSummary = (value) => ({
	type: GET_DRIVETEST_SUMMARY,
	drivetestSummary: value
});

const onGetScannerRoute = (value) => ({
	type: GET_SCANNER_ROUTE,
	scannerRoute: value
});

// Map Compare
const onGetFailuresFiltersSideCompare = (value) => ({
	type: GET_FAILURES_FILTERS_COMPARE,
	failuresFiltersSideCompare: value
});
const onGetFailuresPointsVoiceCompare = (value) => ({
	type: GET_FAILURES_VOICE_COMPARE,
	failuresVoiceCompare: value
});

const onGetFailuresPointsPacketCompare = (value) => ({
	type: GET_FAILURES_PACKET_COMPARE,
	failuresPacketCompare: value
});

const onGetDriveTestsCitiesCompare = (value) => ({
	type: GET_DRIVETESTS_CITIES_COMPARE,
	citiesCompare: value
});

const onGetDriveTestsDrivesCompare = (value) => ({
	type: GET_DRIVETESTS_DRIVES_COMPARE,
	drivesCompare: value
});

const onGetDriveTestsDatesCompare = (value) => ({
	type: GET_DRIVETESTS_DATES_COMPARE,
	datesCompare: value
});

const onSetSelectedDatesCompare = (value) => ({
	type: SET_SELECTED_DATES_COMPARE,
	selectedDatesCompare: value
});

const onGetDriveTestCompare = (value) => ({
	type: GET_DRIVETEST_COMPARE,
	driveTestCompare: value
});

const onGetDriveTestScannerCodesCompare = (value) => ({
	type: GET_DRIVETEST_SCANNER_CODES_COMPARE,
	driveTestScannerCodesCompare: value
});

const onGetDriveTestScannerCompare = (value) => ({
	type: GET_DRIVETEST_SCANNER_COMPARE,
	driveTestScannerCompare: value
});

const onGetTopology2gCompare = (value) => ({
	type: GET_TOPOLOGY_2G_COMPARE,
	topology2gDataCompare: value
});

const onGetTopology3gCompare = (value) => ({
	type: GET_TOPOLOGY_3G_COMPARE,
	topology3gDataCompare: value
});

const onGetTopology4gCompare = (value) => ({
	type: GET_TOPOLOGY_4G_COMPARE,
	topology4gDataCompare: value
});

const onGetTopology5gCompare = (value) => ({
	type: GET_TOPOLOGY_5G_COMPARE,
	topology5gDataCompare: value
});

const onGetTopologyLabels2gCompare = (value) => ({
	type: GET_TOPOLOGY_LABELS_2G_COMPARE,
	topologyLabels2gDataCompare: value
});

const onGetTopologyLabels3gCompare = (value) => ({
	type: GET_TOPOLOGY_LABELS_3G_COMPARE,
	topologyLabels3gDataCompare: value
});

const onGetTopologyLabels4gCompare = (value) => ({
	type: GET_TOPOLOGY_LABELS_4G_COMPARE,
	topologyLabels4gDataCompare: value
});

const onGetTopologyLabels5gCompare = (value) => ({
	type: GET_TOPOLOGY_LABELS_5G_COMPARE,
	topologyLabels5gDataCompare: value
});

const onGetDriveTestsTechBandVoiceCompare = (value) => ({
	type: GET_DRIVETESTS_TECH_BAND_VOICE_COMPARE,
	techBandVoiceCompare: value
});

const onGetDriveTestsTechBandPacketCompare = (value) => ({
	type: GET_DRIVETESTS_TECH_BAND_PACKET_COMPARE,
	techBandPacketCompare: value
});

const onGetDriveTestSummaryCompare = (value) => ({
	type: GET_DRIVETEST_SUMMARY_COMPARE,
	drivetestSummaryCompare: value
});

const onGetScannerRouteCompare = (value) => ({
	type: GET_SCANNER_ROUTE_COMPARE,
	scannerRouteCompare: value
});

// Global
const onToggleFilters = (openFilters) => ({
	type: TOGGLE_FILTERS,
	openFilters,
});

const onClearForm = () => ({
	type: CLEAR_FORM
});

const onToggleSummaryDialog = (visible) => ({
	type: TOGGLE_SUMMARY_DIALOG,
	visible
});

const onToggleCarriersColorsDialog = (visible) => ({
	type: TOGGLE_CARRIERS_COLORS_DIALOG,
	visible
});

const onToggleCarriersColorsPickerDialog = (visible, tableIdColorCode, currentColorCode) => ({
	type: TOGGLE_CARRIERS_COLORS_PICKER_DIALOG,
	visible,
	tableIdColorCode,
	currentColorCode
});

const onGetSitesIds = (value) => ({
	type: GET_SITES_IDS,
	sitesIds: value
});

const onGetSiteIdLocation = (value) => ({
	type: GET_SITE_ID_LOCATION,
	siteIdLocation: value
});

const onGetCarriersColors = (value) => ({
	type: GET_CARRIERS_COLORS,
	carriersColors: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const ResetFields = () => (dispatch) => {
	dispatch(onResetFields());
};

export const GetFailuresFilters = (role) => async (dispatch) => {
	await GetFailuresFiltersRequest(role).then(response => {
		dispatch(onGetFailuresFilters(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetFailuresPointsVoice = (userId, role, city, dates, failureType, cfn1Level) => async (dispatch) => {
	await GetFailuresPointsVoiceRequest(userId, role, 'voice', city, dates, failureType, cfn1Level).then(response => {
		dispatch(onGetFailuresPointsVoice(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetFailuresPointsPacket = (userId, role, city, dates, failureType, cfn1Level) => async (dispatch) => {
	await GetFailuresPointsPacketRequest(userId, role, 'packet', city, dates, failureType, cfn1Level).then(response => {
		dispatch(onGetFailuresPointsPacket(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsCities = (userId, userOperator) => async (dispatch) => {
	await GetDriveTestsCitiesRequest(userId, userOperator).then(response => {
		dispatch(onGetDriveTestsCities(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsDrives = (city) => async (dispatch) => {
	await GetDriveTestsDrivesRequest(city).then(response => {
		dispatch(onGetDriveTestsDrives(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsDates = (city, drive) => async (dispatch) => {
	await GetDriveTestsDatesRequest(city, drive).then(response => {
		dispatch(onGetDriveTestsDates(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetSelectedDates = (selectedDates) => (dispatch) => {
	dispatch(onSetSelectedDates(selectedDates));
};

export const GetDriveTest = (userId, tech, city, dates, kpi) => async (dispatch) => {
	await GetDriveTestRequest(userId, tech, city, dates, kpi).then(response => {
		dispatch(onGetDriveTest(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerCodes = (userId, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerCodesRequest(userId, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerCodes(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScanner = (userId, tech, city, dates, kpi, freq, top, code) => async (dispatch) => {
	await GetDriveTestScannerRequest(userId, tech, city, dates, kpi, freq, top, code).then(response => {
		dispatch(onGetDriveTestScanner(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology2g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '2G', bands, coordinates).then(response => {
		dispatch(onGetTopology2g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology3g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '3G', bands, coordinates).then(response => {
		dispatch(onGetTopology3g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology4g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '4G', bands, coordinates).then(response => {
		dispatch(onGetTopology4g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology5g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '5G', bands, coordinates).then(response => {
		dispatch(onGetTopology5g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopologyLabels2g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyLabelsRequest(userId, '2G', bands, coordinates).then(response => {
		dispatch(onGetTopologyLabels2g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopologyLabels3g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyLabelsRequest(userId, '3G', bands, coordinates).then(response => {
		dispatch(onGetTopologyLabels3g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopologyLabels4g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyLabelsRequest(userId, '4G', bands, coordinates).then(response => {
		dispatch(onGetTopologyLabels4g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopologyLabels5g = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyLabelsRequest(userId, '5G', bands, coordinates).then(response => {
		dispatch(onGetTopologyLabels5g(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsTechBandVoice = (city, dates, userId) => async (dispatch) => {
	await GetDriveTestsTechBandVoiceRequest(city, dates, userId).then(response => {
		dispatch(onGetDriveTestsTechBandVoice(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsTechBandPacket = (city, dates, userId) => async (dispatch) => {
	await GetDriveTestsTechBandPacketRequest(city, dates, userId).then(response => {
		dispatch(onGetDriveTestsTechBandPacket(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestSummaryDropdown = () => async (dispatch) => {
	await GetDriveTestSummaryDropdownRequest().then(response => {
		dispatch(onGetDriveTestSummaryDropdown(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestSummary = (city, dates, scenario) => async (dispatch) => {
	await GetDriveTestSummaryRequest(city, dates, scenario).then(response => {
		dispatch(onGetDriveTestSummary(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestSummaryCompare = (city, dates, scenario) => async (dispatch) => {
	await GetDriveTestSummaryRequest(city, dates, scenario).then(response => {
		dispatch(onGetDriveTestSummaryCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetScannerRoute = (userId, city, dates) => async (dispatch) => {
	await GetScannerRouteRequest(userId, city, dates).then(response => {
		dispatch(onGetScannerRoute(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ToggleFilters = (openFilters) => (dispatch) => {
	dispatch(onToggleFilters(openFilters));
};

export const ClearForm = () => (dispatch) => {
	dispatch(onClearForm());
};

export const ToggleSummaryDialog = (visible) => (dispatch) => {
	dispatch(onToggleSummaryDialog(visible));
};

export const ToggleCarriersColorsDialog = (visible) => (dispatch) => {
	dispatch(onToggleCarriersColorsDialog(visible));
};

export const ToggleCarriersColorsPickerDialog = (visible, tableIdColorCode, currentColorCode) => (dispatch) => {
	dispatch(onToggleCarriersColorsPickerDialog(visible, tableIdColorCode, currentColorCode));
};

// Map Compare
export const GetFailuresFiltersSideCompare = (role) => async (dispatch) => {
	await GetFailuresFiltersRequest(role).then(response => {
		dispatch(onGetFailuresFiltersSideCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetFailuresPointsVoiceCompare = (userId, role, city, dates, failureType, cfn1Level) => async (dispatch) => {
	await GetFailuresPointsVoiceRequest(userId, role, 'voice', city, dates, failureType, cfn1Level).then(response => {
		dispatch(onGetFailuresPointsVoiceCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetFailuresPointsPacketCompare = (userId, role, city, dates, failureType, cfn1Level) => async (dispatch) => {
	await GetFailuresPointsPacketRequest(userId, role, 'packet', city, dates, failureType, cfn1Level).then(response => {
		dispatch(onGetFailuresPointsPacketCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsCitiesCompare = (userId, userOperator) => async (dispatch) => {
	await GetDriveTestsCitiesRequest(userId, userOperator).then(response => {
		dispatch(onGetDriveTestsCitiesCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsDrivesCompare = (city) => async (dispatch) => {
	await GetDriveTestsDrivesRequest(city).then(response => {
		dispatch(onGetDriveTestsDrivesCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsDatesCompare = (city, drive) => async (dispatch) => {
	await GetDriveTestsDatesRequest(city, drive).then(response => {
		dispatch(onGetDriveTestsDatesCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetSelectedDatesCompare = (selectedDates) => (dispatch) => {
	dispatch(onSetSelectedDatesCompare(selectedDates));
};

export const GetDriveTestCompare = (userId, tech, city, dates, kpi) => async (dispatch) => {
	await GetDriveTestRequest(userId, tech, city, dates, kpi).then(response => {
		dispatch(onGetDriveTestCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerCodesCompare = (userId, city, dates, freq, top) => async (dispatch) => {
	await GetDriveTestScannerCodesRequest(userId, city, dates, freq, top).then(response => {
		dispatch(onGetDriveTestScannerCodesCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestScannerCompare = (userId, tech, city, dates, kpi, freq, top, code) => async (dispatch) => {
	await GetDriveTestScannerRequest(userId, tech, city, dates, kpi, freq, top, code).then(response => {
		dispatch(onGetDriveTestScannerCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology2gCompare = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '2G', bands, coordinates).then(response => {
		dispatch(onGetTopology2gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology3gCompare = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '3G', bands, coordinates).then(response => {
		dispatch(onGetTopology3gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology4gCompare = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '4G', bands, coordinates).then(response => {
		dispatch(onGetTopology4gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopology5gCompare = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyRequest(userId, '5G', bands, coordinates).then(response => {
		dispatch(onGetTopology5gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopologyLabels2gCompare = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyLabelsRequest(userId, '2G', bands, coordinates).then(response => {
		dispatch(onGetTopologyLabels2gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopologyLabels3gCompare = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyLabelsRequest(userId, '3G', bands, coordinates).then(response => {
		dispatch(onGetTopologyLabels3gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopologyLabels4gCompare = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyLabelsRequest(userId, '4G', bands, coordinates).then(response => {
		dispatch(onGetTopologyLabels4gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTopologyLabels5gCompare = (userId, bands, coordinates) => async (dispatch) => {
	await GetTopologyLabelsRequest(userId, '5G', bands, coordinates).then(response => {
		dispatch(onGetTopologyLabels5gCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsTechBandVoiceCompare = (city, dates, userId) => async (dispatch) => {
	await GetDriveTestsTechBandVoiceRequest(city, dates, userId).then(response => {
		dispatch(onGetDriveTestsTechBandVoiceCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDriveTestsTechBandPacketCompare = (city, dates, userId) => async (dispatch) => {
	await GetDriveTestsTechBandPacketRequest(city, dates, userId).then(response => {
		dispatch(onGetDriveTestsTechBandPacketCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetScannerRouteCompare = (userId, city, dates) => async (dispatch) => {
	await GetScannerRouteRequest(userId, city, dates).then(response => {
		dispatch(onGetScannerRouteCompare(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// Global
export const GetSitesIds = () => async (dispatch) => {
	await GetSitesIdsRequest().then(response => {
		dispatch(onGetSitesIds(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetSiteIdLocation = (siteId) => async (dispatch) => {
	await GetSiteIdLocationRequest(siteId).then(response => {
		dispatch(onGetSiteIdLocation(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetCarriersColors = () => async (dispatch) => {
	await GetCarriersColorsRequest().then(response => {
		dispatch(onGetCarriersColors(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SaveCarrierColor = (userId, tableId, colorCode) => async (dispatch) => {
	await SaveCarrierColorRequest(userId, tableId, colorCode).then(response => {
		dispatch(GetCarriersColors());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
